import { useState } from 'react';

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      quote: "Their network automation solution transformed our infrastructure management. We've reduced deployment time by 80% and eliminated manual errors completely. The team's expertise in SDWAN and SASE implementation is unmatched.",
      name: "Michael Chen",
      title: "CTO",
      company: "TechCorp Global",
      avatar: "https://public.readdy.ai/ai/img_res/56dd5a3c6abcb4c053139694c150247c.jpg"
    },
    {
      quote: "The AI/ML training program exceeded our expectations. Our team gained practical skills in Gen-AI and RAG that we immediately applied to production projects. The instructors are industry experts who understand real-world challenges.",
      name: "Sarah Johnson",
      title: "VP of Engineering",
      company: "DataFlow Systems",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20confident%20female%20technology%20executive%20with%20blonde%20hair%20in%20business%20attire%20against%20clean%20white%20background%2C%20modern%20corporate%20photography%20style%2C%20sharp%20focus%2C%20professional%20lighting&width=200&height=200&seq=testimonial-avatar-002&orientation=squarish"
    },
    {
      quote: "Outstanding data center migration support. They handled our complex Cisco ACI to NDFC migration with zero downtime. Their automated assessment tools identified optimization opportunities we hadn't considered.",
      name: "David Martinez",
      title: "Infrastructure Director",
      company: "CloudScale Enterprises",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20confident%20Hispanic%20male%20technology%20director%20in%20business%20attire%20against%20clean%20white%20background%2C%20modern%20corporate%20photography%20style%2C%20sharp%20focus%2C%20professional%20lighting&width=200&height=200&seq=testimonial-avatar-003&orientation=squarish"
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-br from-teal-50 via-cyan-50 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Left Side */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-4">
              <div className="w-2 h-2 rounded-full bg-teal-600 mr-2"></div>
              <span className="text-teal-600 text-sm font-semibold tracking-wider uppercase">
                CLIENT SUCCESS STORIES
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-serif text-gray-900 mb-6 leading-tight">
              "Transforming businesses through innovative technology solutions"
            </h2>
            <div className="mt-8">
              <div className="text-lg font-bold text-gray-900">{testimonials[activeIndex].name}</div>
              <div className="flex items-center mt-2">
                <span className="text-gray-600">{testimonials[activeIndex].company}</span>
                <i className="ri-verified-badge-fill text-teal-600 ml-2"></i>
                <span className="text-sm text-gray-500 ml-1">Verified Client</span>
              </div>
            </div>
          </div>

          {/* Right Side - Testimonial Card */}
          <div className="lg:col-span-3">
            <div className="bg-white rounded-2xl p-10 shadow-xl relative">
              <i className="ri-double-quotes-l text-6xl text-teal-600 opacity-20 absolute top-6 left-6"></i>
              
              <p className="text-xl text-gray-700 leading-relaxed mb-8 relative z-10">
                {testimonials[activeIndex].quote}
              </p>

              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <div className="w-12 h-12 rounded-full overflow-hidden mr-4">
                    <img
                      src={testimonials[activeIndex].avatar}
                      alt={testimonials[activeIndex].name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">{testimonials[activeIndex].name}</div>
                    <div className="text-sm text-gray-600">{testimonials[activeIndex].title}</div>
                  </div>
                </div>
              </div>

              {/* Navigation Dots */}
              <div className="flex justify-center mt-8 space-x-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveIndex(index)}
                    className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                      index === activeIndex ? 'bg-teal-600 w-8' : 'bg-gray-300'
                    }`}
                  ></button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
